

















import { Component, Prop, Model, Watch } from 'vue-property-decorator';
import { SurveySingleSelectOptions } from '@/models/survey-elements/single-select-options';
import ChoiceElementMixin from '@/mixins/choiceElementMixin';
const SINGLE_SELECT_TYPE = {
  HORIZONTAL: 1,
  VERTICAL: 3,
};

@Component({
  name: 'single-select-group',
})
export default class SingleSelectGroup extends ChoiceElementMixin {
  @Model('change', { type: Object }) value!: Partial<SurveySingleSelectOptions>;
  @Prop({ type: Number, default: SINGLE_SELECT_TYPE.HORIZONTAL })
  orientation!: number;

  private localValue: Partial<SurveySingleSelectOptions> | null = this.value;
  private additionalFieldLabel?: string;
  private isTextFieldVisible = false;

  private get orientationClasses() {
    return {
      'flex-col space-y-3': this.orientation === SINGLE_SELECT_TYPE.VERTICAL,
      'flex space-x-3 justify-between':
        this.orientation === SINGLE_SELECT_TYPE.HORIZONTAL,
    };
  }

  onCustomValueChange(label: string) {
    this.localValue = { ...this.localValue, label, allowCustomValue: true };
    this.$emit('change', this.localValue);
  }

  mounted() {
    this.$on('toggle-additional-field', this.toggleAdditionalField);
  }

  private async toggleAdditionalField({
    allowCustomValue,
    label,
    value,
  }: SurveySingleSelectOptions) {
    await this.$nextTick();
    const option = { label, value };
    this.isTextFieldVisible = allowCustomValue;
    this.localValue = this.isTextFieldVisible ? option : null;
    this.additionalFieldLabel = option.label;
    if (this.isTextFieldVisible && this.localValue) {
      this.$emit('change-custom-value', this.localValue);
      this.localValue.label = '';
    }

    if (!this.isTextFieldVisible && this.localValue) {
      this.localValue.label = option.label;
    }
  }

  @Watch('isTextFieldVisible')
  private onIsTextFieldVisibleChange(currentValue: boolean) {
    this.setFocus(currentValue);
  }
}
